import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { useToast } from '../hooks/use-toast';
import { LogIn } from 'lucide-react';

const ADMIN_ROLES = ['Manager', 'Operator'];

const Login = () => {
  const [loginId, setLoginId] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const result = await login(loginId, password);

    if (result.success) {
      toast({ title: 'Login realizado com sucesso!', description: 'Você será redirecionado...' });
      setTimeout(() => {
        if (result.role === 'SmartPayAdmin') navigate('/platform/dashboard');
        else if (ADMIN_ROLES.includes(result.role)) navigate('/admin/dashboard');
        else navigate('/app/dashboard');
      }, 500);
    } else {
      toast({ variant: 'destructive', title: 'Erro no login', description: result.error || 'Verifique suas credenciais' });
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-950 dark:to-slate-900">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1763655211913-342743af6caf?crop=entropy&cs=srgb&fm=jpg&q=85')] bg-cover bg-center opacity-5" />
      <Card className="relative w-full max-w-md shadow-2xl">
        <CardHeader className="space-y-4 text-center">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
            <LogIn className="h-8 w-8 text-primary" strokeWidth={1.5} />
          </div>
          <CardTitle className="text-3xl font-bold tracking-tight">ItechPay</CardTitle>
          <CardDescription className="text-base">Entre com suas credenciais para acessar</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="email">E-mail</Label>
              <Input id="email" type="text" placeholder="seu@email.com" value={loginId} onChange={(e) => setLoginId(e.target.value)} required className="h-11" data-testid="login-email-input" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Senha</Label>
              <Input id="password" type="password" placeholder="••••••••" value={password} onChange={(e) => setPassword(e.target.value)} required className="h-11" data-testid="login-password-input" />
            </div>
            <div className="flex justify-end"><Link to="/forgot-password" className="text-sm font-medium text-primary hover:underline">Esqueci minha senha</Link></div>
            <Button type="submit" className="w-full h-11 rounded-full shadow-lg hover:shadow-xl" disabled={loading} data-testid="login-submit-button">{loading ? 'Entrando...' : 'Entrar'}</Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default Login;
